import React, { Component } from "react";
import * as BABYLON from '@babylonjs/core';
/*import { Engine } from "@babylonjs/core/Engines/engine";
import { Scene } from "@babylonjs/core/scene";
import { ArcRotateCamera } from "@babylonjs/core/Cameras/arcRotateCamera";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { HemisphericLight } from "@babylonjs/core/Lights/hemisphericLight";
import { SceneLoader } from "@babylonjs/core/Loading/sceneLoader";
import { CubeTexture } from "@babylonjs/core/Materials/Textures/cubeTexture";
import { EnvironmentHelper } from "@babylonjs/core/Helpers/environmentHelper";
*/
import { SceneInstrumentation } from "@babylonjs/core/Instrumentation/sceneInstrumentation";
// required imports
import "@babylonjs/core/Loading/loadingScreen";
import "@babylonjs/core/Materials/standardMaterial";
import "@babylonjs/core/Materials/Textures/Loaders/envTextureLoader";

import ParameterErrors from '../errors/ParameterErrors';
import Iterator from '../core/Iterator';
import FrequencyLimitedCallback from '../core/FrequencyLimitedCallback';
const { throwNotProvided } = ParameterErrors;
class BabylonScene {
    constructor(props) {
        const { onReadyToAddSceneComponents } = props;
        this._rendering = false;
        this._scene = null;
        if (!onReadyToAddSceneComponents) throwNotProvided('onReadyToAddSceneComponents');
		this._onReadyToAddSceneComponents = onReadyToAddSceneComponents;
        this.defaultCamerasAndLight = this.defaultCamerasAndLight.bind(this);
        this._onWindowResize = this._onWindowResize.bind(this);
        this.startRendering = this.startRendering.bind(this);
        this.stopRendering = this.stopRendering.bind(this);
        this.setRendering = this.setRendering.bind(this);
        this._rendeLoop = this._rendeLoop.bind(this);
        this.babylonModelAdded = this.babylonModelAdded.bind(this);
        this._babylonModelDisposed = this._babylonModelDisposed.bind(this);
        this.fromRotationMatrixToRef = this.fromRotationMatrixToRef.bind(this);
        this._updateVisibleObjects = this._updateVisibleObjects.bind(this);
        this._cameraPositionOrRotationChanged = this._cameraPositionOrRotationChanged.bind(this);
        this.dispose = this.dispose.bind(this);
        this._setScalingRotationAndPosition = this._setPositionRotationAndScaling.bind(this);
        this.setNTimesInitialCameraRadius = this.setNTimesInitialCameraRadius.bind(this);
		this._babylonModels=[];
		this._updateVisibleObjectsFrequencyLimitedCallback = new FrequencyLimitedCallback({frequencyHz:6});
		this._canvas = document.createElement('canvas');
        this._canvas.style.width = '100%';
		this._canvas.style.height = '100%';
        this._engine = new BABYLON.Engine(this._canvas, true);
        this._scene = new BABYLON.Scene( this._engine);
		const sceneInstrumentation = new SceneInstrumentation(this._scene);
        window.addEventListener("resize", this._onWindowResize, false);
		setTimeout(()=>{
			 this._engine.resize();
			this._onReadyToAddSceneComponents();
		}, 0);
    }
	babylonModelAdded(babylonModel){
		babylonModel.addEventListener('disposed', this._babylonModelDisposed);
		this._babylonModels.push(babylonModel);
	}
	_babylonModelDisposed(e){
		const {babylonModel}=e;
		const index = this._babylonModels.indexOf(babylonModel);
		if(index<0)return;
		this._babylonModels.splice(index, 1);
	}
	get element(){
		return this._canvas;
	}
    get scene() {
        return this._scene;
    }
    get canvas() {
        return this._canvas;
    }
	get camera(){
		return this._camera;
	}
    defaultCamerasAndLight(params) {
		params = params||{attachCameraControls:true}
        //this._scene.createDefaultCameraOrLight(true, true, params.attachCameraControls);
        this._scene.createDefaultEnvironment();
		setInterval(()=>{
		this._scene.createDefaultLight();
        this._scene.lights[0].intensity = 20;
		});
		this._camera = new BABYLON.FreeCamera("camera", BABYLON.Vector3.Zero(), this._scene);
        this._initialCameraRadius = this._camera.radius;
    }
    setNTimesInitialCameraRadius(n) {
		console.log('this._camera.radius');
		console.log(this._camera.radius);
        this._camera.radius = this._initialCameraRadius * n;
    }
	
	setCameraPosition(position){
		this._camera.position = position;
		this._cameraPositionOrRotationChanged();
	}
	addInPlace(scaledDirection){
		this._camera.position.addInPlace(scaledDirection);
		this._cameraPositionOrRotationChanged();
	}
	fromRotationMatrixToRef(rotationMatrix){
		BABYLON.Quaternion.FromRotationMatrixToRef(rotationMatrix, this._camera.rotationQuaternion);
		this._cameraPositionOrRotationChanged();
	}
	getCameraPosition(){
		return this._camera.position;
	}
    startRendering() {
        this.setRendering(true);
    }
    stopRendering() {
        this.setRendering(false);
    }
    setRendering(value) {
        if (!(this._rendering ^ value)) return;
        this._rendering = value;
        if (value) {
             this._engine.runRenderLoop(this._rendeLoop);
            return;
        }
         this._engine.stopRenderLoop(this._rendeLoop);
    }
	_cameraPositionOrRotationChanged(){
		this._updateVisibleObjectsFrequencyLimitedCallback.trigger(this._updateVisibleObjects);
	}
	_updateVisibleObjects(){
		const p = this._camera.position;
		const x = -p.x;
		const z = -p.z;
		const y = p.y;
		if(window.objectIdsToShow){
			for(var babylonModel of this._babylonModels){
				console.log(window.objectIdsToShow);
				babylonModel.setVisibleObjects(window.objectIdsToShow);
			}
			return;
		}
		if(window.setAllObjectsVisible){
				
			for(var babylonModel of this._babylonModels){
				babylonModel.setAllObjectsVisible();
			}
			return;
		}
		let objectIdsToShow = [];
		const eulerAngles = this._camera.rotationQuaternion.toEulerAngles();
		const yawRadians =eulerAngles.y, pitchRadians=-eulerAngles.x;
		for(var babylonModel of this._babylonModels){
			const reasonsOut ={};
			const objectIdsToShow = babylonModel.quadrants.getObjectIds({yawRadians, pitchRadians, x, y, z, reasonsOut});
			const {reasons }= reasonsOut;
			if(reasons){
				console.log('reasons');
				console.log(reasons);
				reasons.forEach(reason=>{
					console.log(reason.description);
				});
			}
			babylonModel.setVisibleObjects(objectIdsToShow);
		}
	}
    _setPositionRotationAndScaling(root, position, rotation, scaling) {
        root.position = new BABYLON.Vector3(position.x, position.y, position.z);
        root.rotation = new BABYLON.Vector3(rotation.x, rotation.y, rotation.z); 
        root.scaling = new BABYLON.Vector3(scaling.x, scaling.y, scaling.z);
    }
    _scheduleApplyTextureToMesh(mesh, babylonMesh, materialsManager) {
        materialsManager.getBabylonMaterialByName(mesh.material).then((babylonMaterial) => {
            babylonMesh.material = babylonMaterial;
        }).catch(console.error);
    }
    _rendeLoop() {
        this._scene.render();
    }
    _onWindowResize = event => {
         this._engine.resize();
    };
	dispose(){
        window.removeEventListener("resize", this._onWindowResize, false);
	}
}
export default BabylonScene;